import { DynamicConfig } from '../models';

export const DEFAULT_DYNAMIC_CONFIG: DynamicConfig = {
  device: 'mobile',
  instance: 'ebdemo',
  lang: 'en',
  searchLang: 'en',
  scope: 'mobile',
  currency: 'EUR',
  filters: {},
  consent: false,
  documentDirection: 'ltr'
};
